'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var themeTools = require('@chakra-ui/theme-tools');
var text = require('./text.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var MONO_COLORS = ['black', 'white'];
var variantDefault = function variantDefault(props) {
  var c = props.colorScheme,
    theme = props.theme;

  // Differentiate `MONO_COLORS` from regular colors. They can not be used
  // as `${c}.400` because no scale exists for them.
  return MONO_COLORS.includes(c) ? {
    color: c,
    _hover: {
      color: c
    }
  } : {
    color: "".concat(c, ".400"),
    _hover: {
      color: themeTools.darken("".concat(c, ".400"), 30)(theme)
    }
  };
};
var variantUnderline = function variantUnderline(props) {
  var solid = variantDefault(props);
  return _objectSpread(_objectSpread({}, solid), {}, {
    _hover: _objectSpread(_objectSpread({}, solid._hover), {}, {
      textDecoration: 'underline'
    })
  });
};
var variantUnstyled = {
  color: 'inherit',
  textDecoration: 'none'
};
var baseStyle = function baseStyle(props) {
  var as = props.as;
  return _objectSpread({
    transitionProperty: 'common',
    transitionDuration: 'fast',
    transitionTimingFunction: 'ease-out',
    cursor: 'pointer',
    textDecoration: 'none',
    outline: 'none'
  }, as === 'button' && {
    touchAction: 'manipulation',
    _disabled: {
      color: 'gray.400',
      cursor: 'not-allowed'
    },
    // Lines below this comment are for bootstrap-compatibility.
    border: 'none',
    background: 'none',
    _focus: {
      outline: 'none'
    }
  });
};
var defaultProps = {
  colorScheme: 'blue',
  variant: 'default',
  size: 'md'
};
var sizes = text["default"].sizes;
var variants = {
  "default": variantDefault,
  underline: variantUnderline,
  unstyled: variantUnstyled
};
var Link = {
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Link;